<Title name="{"Local"}" />

<LazyPage {pageComponent} {params} />

<script>
  import Title from './_components/Title.html'
  import LazyPage from './_components/LazyPage.html'
  import pageComponent from './_pages/local.html'

  export default {
    components: {

      Title,
      LazyPage
    },
    data: () => ({
      pageComponent
    })
  }
</script>
